import { REPORT_PREVIEW_ACTIONS } from '../constants/report-preview.constants';
import * as immutable from 'immutable';
import { IgenomicsAction } from '../../../core/interfaces/genomics-action.interface';

export interface IreportPreviewState {
  reportData: immutable.Map<string, any>;
}

const storeToCache = function (state, userId) {
  const key = `uc-${userId}`;
  let storedState = localStorage.getItem(key);
  storedState = storedState ? JSON.parse(storedState) : { };
  Object.assign(storedState, { 'reportPreview': state});
  localStorage.setItem(key, JSON.stringify(storedState));
};

const loadFromCache = function (state) {
  const reportData = state && state.reportPreview.reportData ? immutable.fromJS(state.reportPreview.reportData) : <immutable.Map<string, any>> immutable.Map();
  return { reportData: reportData};
};

const InitReportPreviewState: IreportPreviewState = {
  reportData: <immutable.Map<string, any>> immutable.Map()
};

export function reportPreviewReducer(state: IreportPreviewState = InitReportPreviewState, action: IgenomicsAction): IreportPreviewState {
  switch (action.type) {
    case REPORT_PREVIEW_ACTIONS.SET_STATE:
      return loadFromCache(action.payload.state);
    default:
      return state;
  }
}

